"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable  @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-misused-promises*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
var CartCard_1 = __importDefault(require("./CartCard"));
var AxiosClient_1 = require("../utils/AxiosClient");
var js_cookie_1 = __importDefault(require("js-cookie"));
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var formatCurrency_1 = require("../utils/formatCurrency");
var functions_1 = require("../interfaces/functions");
var Payment_1 = __importDefault(require("@mui/icons-material/Payment"));
var CartView = function () {
    var token = js_cookie_1.default.get("token");
    var _a = (0, react_1.useState)(0), total = _a[0], setTotal = _a[1];
    var _b = (0, react_1.useState)(false), disabled = _b[0], setDisabled = _b[1];
    var _c = (0, react_1.useState)([]), cartList = _c[0], setCartList = _c[1];
    var handleClearCart = function () {
        setDisabled(true);
        AxiosClient_1.AxiosClient.delete("/cart/clear", {
            headers: { Authorization: "Bearer ".concat(token) },
        })
            .then(function (response) {
            if (response.data.statusCode == 200) {
                setDisabled(false);
                window.location.reload();
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () {
            setDisabled(false);
        });
    };
    (0, react_1.useEffect)(function () {
        AxiosClient_1.AxiosClient.get("/cart/view", {
            headers: {
                Authorization: "Bearer ".concat(token),
            },
        })
            .then(function (response) {
            // setCartList(response.data)
            setTotal(response.data.cart.Total);
            var list = [];
            response.data.cart.CartItems.forEach(function (item) {
                list.push({
                    id: item.id,
                    image: item.image,
                    productName: item.ProductName,
                    price: item.price,
                    quantity: item.quantity,
                });
                setCartList(list);
            });
        })
            .catch(function (Error) {
            console.log(Error);
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Navbar_1.default, { iconNumber: 3 }),
        react_1.default.createElement(material_1.Container, { maxWidth: "sm", sx: {
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
            } },
            total > 0 && (react_1.default.createElement(material_1.Container, { component: "main", maxWidth: "sm", sx: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "2rem",
                } },
                react_1.default.createElement(material_1.Button, { variant: "contained", color: "primary", size: "large", onClick: function () { return (0, functions_1.Checkout)(); }, startIcon: react_1.default.createElement(Payment_1.default, null) }, "Pay Now"))),
            cartList.map(function (cart, index) {
                return (react_1.default.createElement(CartCard_1.default, { key: index, image: cart.image, productName: cart.productName, quantity: cart.quantity, price: cart.price, id: cart.id }));
            }),
            react_1.default.createElement("div", { style: {
                    padding: "25px",
                    display: "flex",
                    justifyContent: "space-between",
                } },
                react_1.default.createElement(material_1.Button, { variant: "outlined", onClick: handleClearCart, disabled: disabled, startIcon: react_1.default.createElement(icons_material_1.DeleteForever, null), color: "error" }, "Clear Cart"),
                react_1.default.createElement(material_1.Typography, { sx: { fontWeight: 700 } }, (0, formatCurrency_1.formatCurrency)(total))))));
};
exports.default = CartView;
